<template>
  <div class="select-box" v-clickoutside="offList">
    <div @click="changelist">
      <el-input :placeholder="placeholder" v-model="key" @input="remoteMethod" @keyup.enter.native="offList"></el-input>
    </div>
    <transition name="fade">
      <div class="select-list" v-show="showList">
        <ul>
          <li
          v-for="(item, index) in selectList"
          :key="index" :value="item[dataKey]"
          :class="{ 'hover':index === hoverIndex}"
          @mouseover="hoverIndex = index"
          @click="selectKey(item)"
          >
            {{ item[label] }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
const clickoutside = {
  // 初始化指令
  bind (el, binding, vnode) {
    function documentHandler (e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update () {},
  unbind (el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}

export default {
  name: 'NameSelect',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    remote: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: function () {
        return []
      }
    },
    label: {
      type: String,
      default: 'Name'
    },
    dataKey: {
      type: String,
      default: 'Id'
    }
  },
  watch: {
    value (newValue) {
      this.$set(this, 'key', newValue)
    },
    selectList (newValue) {
      this.onList()
    }
  },
  data () {
    return {
      key: '',
      dataOBJ: {},
      list: [],
      hoverIndex: 0,
      showList: false
    }
  },
  directives: { clickoutside },
  methods: {
    remoteMethod () {
      const OJB = {}
      OJB[this.label] = this.key
      OJB[this.dataKey] = this.key
      OJB.baseData = {}
      this.$emit('getOBJ', OJB)
      if (this.remote) this.$emit('remoteMethod', this.key)
    },
    selectKey (key) {
      this.hoverIndex = 0
      const OJB = {}
      OJB[this.label] = key[this.label]
      OJB[this.dataKey] = key[this.dataKey]
      OJB.baseData = key
      this.$set(this, 'key', key[this.dataKey])
      this.$emit('getOBJ', OJB)
      this.$nextTick(() => {
        this.offList()
      })
    },
    changelist () {
      if (this.selectList.length > 0) {
        if (this.showList) this.offList()
        else this.onList()
      }
    },
    onList () {
      if (this.selectList.length > 0) {
        this.$set(this, 'showList', true)
      } else {
        this.offList()
      }
    },
    offList () {
      this.$set(this, 'showList', false)
    }
  },
  created () {
    this.$set(this, 'key', this.value)
  }
}
</script>
<style lang="scss" scoped>
.select-box {
  width: 100%;
  position: relative;
  .select-list {
    position: absolute;
    top: 31px;
    left: 0;
    z-index: 99999;
    background: #fff;
    width: 100%;
    max-height: 192px;
    overflow: auto;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 5px 0;
    ul {
      overflow: hidden;
      transition: .2s ease-in;
    }
      li {
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
      }
      .hover {
        background-color: #F5F7FA;
      }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s;
  height: auto;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  height: 0;
}
</style>
